import { LocalizationStore } from "@faire/web/common/localization/LocalizationStore";
import { prependLocaleToUrl } from "@faire/web/ui/routing/util";
export var localizePath = function localizePath(path) {
  return prependLocaleToUrl(path, {
    locale: LocalizationStore.get().locale
  });
};